'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('../');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _AboutBanner = require('./AboutBanner.css');

var _AboutBanner2 = _interopRequireDefault(_AboutBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AboutBanner = (_dec = (0, _reactCssModules2.default)(_AboutBanner2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AboutBanner, _Component);

  function AboutBanner(props) {
    (0, _classCallCheck3.default)(this, AboutBanner);
    return (0, _possibleConstructorReturn3.default)(this, (AboutBanner.__proto__ || (0, _getPrototypeOf2.default)(AboutBanner)).call(this, props));
  }

  (0, _createClass3.default)(AboutBanner, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'about-banner' },
        _react2.default.createElement(
          _.Link,
          {
            to: _config2.default.routes.about,
            title: 'Learn more'
          },
          _react2.default.createElement(
            'div',
            { styleName: 'about-banner__flex' },
            _react2.default.createElement(
              'div',
              { styleName: 'about-banner__copy' },
              _react2.default.createElement(
                'h2',
                { styleName: 'about-banner__title' },
                'Defund deforestation'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'about-banner__lede' },
                'Built for investors who want to make a difference. Our unique dataset can help you ensure your money is making an impact.'
              ),
              _react2.default.createElement(
                'btn',
                { styleName: 'about-banner__button' },
                'Learn more',
                _react2.default.createElement(_.LinkIcon, null)
              )
            ),
            _react2.default.createElement('div', { styleName: 'about-banner__img' })
          )
        )
      );
    }
  }]);
  return AboutBanner;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class);
exports.default = AboutBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutBanner/AboutBanner.js
// module id = 1314
// module chunks = 0